module.exports = __webpack_public_path__ + "0dcda5d510bc7d164208cde92865dbc0.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-location.svg
// module id = zbw2
// module chunks = 5